// extracted by mini-css-extract-plugin
export var header = "_v4-1";
export var maskBottom = "_v4-6";
export var maskMiddle = "_v4-7";
export var maskTop = "_v4-5";
export var root = "_v4-0";
export var scrollDownButton = "_v4-3";
export var scrollDownButtonHidden = "_v4-4";
export var viewport = "_v4-2";